module.exports = __webpack_public_path__ + "img/1431097070.e448d5af.jpg";